import { Component, Input, ViewChild } from '@angular/core';
import { SeahorseTemplateDirective } from '@seahorse/common';

@Component({
  selector: 'sh-tab',
  template: ` <ng-content *shTemplate></ng-content> `,
  styles: [`:host {display: block}`],
  standalone: true,
  imports: [SeahorseTemplateDirective],
})
export class TabComponent {
  @Input() title?: string;
  @ViewChild(SeahorseTemplateDirective) template?: SeahorseTemplateDirective;
}
